<template>
    <div class="loading">
        loading
    </div>
</template>
  
<script>
import {getQueryString} from "@/util/util.js";
import func from "@/util/func.js";
import {refreshToken}  from "@/api/base.js";
import {userStore} from "@/store/user";


export default {
    name: 'loadingpage',
    data() {
    return {
      name: 'home'
        }
    },
    setup(){
    const user = userStore();
      return {
        // 为了能在模板中使用它，你可以返回整个 Store 实例。
        user
      }
    },
    components: {
     
    },
    mounted(){
         // this.testToken()
    },
    methods:{
    //     testToken(){
    //       let that=this;
    //       let token = func.getParam(window.location.href,'token');
    //       console.log(token);
    //       if(!func.isEmpty(token)){
    //         //刷新TOKEN
    //         let tenantId = func.getParam(window.location.href,'tenantId');
    //         let clinicId = func.getParam(window.location.href,'clinicId');
           
    //         refreshToken(token,tenantId, {
    //           clinic_id: clinicId
    //         }).then(res => {
    //           const data = res.data;
    //           // console.log(data);
    //           this.user.setUserInfo(data);
    //           this.$router.push({ name: 'home'})
    //           // commit('SET_TOKEN', data.access_token);
    //           // commit('SET_REFRESH_TOKEN', data.refresh_token);
    //           //resolve();
    //         }).catch(error => {
    //          console.log(error)
    //           // reject(error)
    //         })
    //       }

    //     }
    } 
  }

</script>